module["exports"] = [
  "63[7-9]#-####-####-###L"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/finance/credit_card/instapayment.js
// module id = 2650
// module chunks = 1610